import UpsellingMeliplusCashback from '../../../../../pages/vip/features/upselling-meliplus-cashback/upselling-meliplus-cashback.mobile';

export default UpsellingMeliplusCashback;
